export class BlobUtils {
  static async blobToString(blob: Blob): Promise<string> {
    const blobString = new Blob([blob], { type: 'text/html' });
    return await blobString.text();
  }
}
